import * as ifr from "./action-type";
import renameActionType from "Store/renameActionType";
renameActionType(ifr, "ifr");

let defaultState = {
    allowPaint: false // 是否允许渲染
};
// 首页表单数据
export const ifrData = (state = defaultState, action = {}) => {
    switch (action.type) {
        case ifr.ALLOWPAINT:
            return { ...state, allowPaint: action.data };
        default:
            return state;
    }
};
